var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _rect, _path, _rect2, _path2, _rect3, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceMindfulness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 141,
    viewBox: "0 0 270 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.3845,
    cy: 56.4616,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7692,
    cy: 64.4616,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9997,
    cy: 83.5388,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2311,
    cy: 66.9235,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8464,
    cy: 82.3073,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.0005,
    cy: 70.0005,
    r: 9.84615,
    fill: "#F3BB40"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.384,
    cy: 56.4616,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.769,
    cy: 64.4616,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 83.5388,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.231,
    cy: 66.9235,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.846,
    cy: 82.3073,
    r: 14.7692,
    fill: "#F9D5E9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 70.0005,
    r: 9.84615,
    fill: "#F3BB40"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.231,
    cy: 53.0768,
    r: 18.4615,
    fill: "#F9D5E9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.462,
    cy: 63.0768,
    r: 18.4615,
    fill: "#F9D5E9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 86.9235,
    r: 18.4615,
    fill: "#F9D5E9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.539,
    cy: 66.1539,
    r: 18.4615,
    fill: "#F9D5E9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.307,
    cy: 85.3844,
    r: 18.4615,
    fill: "#F9D5E9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 70.0001,
    r: 12.3077,
    fill: "#F3BB40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 100L156.5 104L163.5 96",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 100L60.5 104L67.5 96",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 84,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 100,
    r: 2,
    fill: "#24284E"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 136,
    r: 2,
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 30,
    r: 2,
    fill: "white"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 15.5,
    r: 1.5,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 24.5,
    r: 1.5,
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174 17L187 30",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.5 6.5L244 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 114L178.5 126",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 124.5L241.5 138.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceMindfulness);
export default __webpack_public_path__ + "static/media/persistence-mindfulness.44b4d9db475c99e30e2fd02cbf42d6d7.svg";
export { ForwardRef as ReactComponent };